import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Typography } from 'ha/ui/next/Typography';
import Button from 'ha/ui/next/Button';

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: '1.875rem',
    display: 'inline-flex',
  },
  text: {
    marginLeft: '1rem',
  },
}));

interface Props {
  icon: React.ReactElement;
  title: string;
  caption: string;
  url: string;
  noFollow: boolean;
}

const LearnItem: React.FC<Props> = ({
  icon,
  title,
  caption,
  url,
  noFollow,
}) => {
  const classes = useStyles();

  return (
    <Button
      variant="text"
      iconSize="large"
      href={url}
      rel={noFollow ? 'no-follow' : undefined}
    >
      <div className={classes.icon}>{icon}</div>
      <div className={classes.text}>
        <Typography.ParagraphTitle textTransform="none">
          {title}
        </Typography.ParagraphTitle>
        <Typography.Caption color="muted" textTransform="none">
          {caption}
        </Typography.Caption>
      </div>
    </Button>
  );
};

export default LearnItem;
